import * as Sentry from '@sentry/nuxt'

Sentry.init({
  dsn: useRuntimeConfig().public.SENTRY_DSN,
  sendDefaultPii: true,
})
